/*
 * Copyright (C) 2022 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {UpdateFilter} from './screener-filter.action';
import {Filters} from '../modals/Filters';

export class ScreenerFilterStateModel {
  screenerFilters: Filters = new Filters();
}

@State<ScreenerFilterStateModel>({
  name: 'screenerFilters',
  defaults: {
    screenerFilters: new Filters()
  }
})
@Injectable()
export class ScreenerFilterState {

  constructor() {
  }

  @Selector()
  static getScreenerFilter(state: ScreenerFilterStateModel): any {
    return state.screenerFilters;
  }

  @Action(UpdateFilter)
  updateFilter({getState, setState}: StateContext<ScreenerFilterStateModel>, {payload}: UpdateFilter): any {
    const state = getState();
    setState({
      ...state,
      screenerFilters: payload
    });
  }

}
